/**
 * Quantity Offers v5 — PDP selection + Releasit COD sync + free shipping flag
 */
(function () {
  'use strict';

  var FREE_SHIP_STORAGE = 'rsi_qo_free_shipping';
  var SELECTORS = {
    OFFER_CARD: '.qov4__card',
    SELECTED_CLASS: 'qov4__card--selected',
    RADIO_INPUT: '.qov4__radio-input',
    FORM_CONTAINER: '#rsi-cod-form-quantity-offers-hook',
    OFFERS_CONTAINER: '._rsi-quantity-offers',
    OFFER_CONTAINER: '._rsi-quantity-offers-offer-container',
    RELEASIT_SELECTED: '_rsi-quantity-offers-selected',
  };

  window.__qov5Instances = window.__qov5Instances || [];
  window.__qov5Initialized = window.__qov5Initialized || {};

  function createStorage(key) {
    return {
      get: function () {
        try {
          var data = localStorage.getItem(key);
          return data ? JSON.parse(data) : null;
        } catch (e) {
          return null;
        }
      },
      set: function (data) {
        try {
          localStorage.setItem(key, JSON.stringify(data));
        } catch (e) { /* ignore */ }
      },
      clear: function () {
        try {
          localStorage.removeItem(key);
        } catch (e) { /* ignore */ }
      },
    };
  }

  function cardHasFreeShipping(card) {
    return !!(card && card.dataset && card.dataset.freeShipping === 'true');
  }

  function publishFreeShipping(enabled) {
    window._rsiQoFreeShipping = !!enabled;
    try {
      localStorage.setItem(FREE_SHIP_STORAGE, enabled ? '1' : '0');
    } catch (e) { /* ignore */ }

    try {
      document.dispatchEvent(
        new CustomEvent('rsi-qo-free-shipping-change', { detail: { enabled: !!enabled } })
      );
    } catch (e2) { /* ignore */ }

    if (typeof window._rsiSyncQoFreeShipping === 'function') {
      window._rsiSyncQoFreeShipping();
    }
  }

  function buildSelectionFromCard(card) {
    return {
      variantId: card.dataset.variantId,
      offerIndex: parseInt(card.dataset.offerIndex, 10),
      optionValue: card.dataset.optionValue,
      quantity: card.dataset.offerQuantity,
      freeShipping: cardHasFreeShipping(card),
      timestamp: Date.now(),
    };
  }


  function QuantityOffersV5(config) {
    if (window.__qov5Initialized[config.sectionId]) return;
    window.__qov5Initialized[config.sectionId] = true;

    this.config = config;
    this.storage = createStorage(config.storageKey);
    this.section = document.querySelector(config.sectionSelector);
    this.ctaButton = null;
    this.offerCards = [];
    this.selectedOfferIndex = null;
    this.isProcessing = false;

    if (!this.section) return;

    window.__qov5Instances.push(this);
    this.init();
  }

  QuantityOffersV5.prototype.init = function () {
    this.storage.clear();

    this.offerCards = Array.prototype.slice.call(
      this.section.querySelectorAll(SELECTORS.OFFER_CARD)
    );
    this.ctaButton =
      document.getElementById(this.config.ctaButtonId) ||
      this.section.querySelector('[id^="qov5-main-cta-"]');

    if (this.offerCards.length > 1) {
      this.selectCard(this.offerCards[1], 1);
    } else if (this.offerCards.length === 1) {
      this.selectCard(this.offerCards[0], 0);
    }

    this.attachEventListeners();
    this.setupReleasitObserver();
    this.exposeDebugAPI();
  };

  QuantityOffersV5.prototype.getSelectedCard = function () {
    if (this.selectedOfferIndex === null) return null;
    return this.offerCards[this.selectedOfferIndex] || null;
  };

  QuantityOffersV5.prototype.syncFromPdpImmediate = function () {
    var card = this.getSelectedCard();
    if (!card) return;

    window.__rsiQoModalOfferOverride = false;

    var selectionData = buildSelectionFromCard(card);
    this.storage.set(selectionData);
    publishFreeShipping(selectionData.freeShipping);
  };

  QuantityOffersV5.prototype.syncFromPdpIfSelected = function () {
    this.syncFromPdpImmediate();

    var self = this;
    setTimeout(function () {
      self.syncWithReleasit();
    }, 350);
  };

  QuantityOffersV5.prototype.attachEventListeners = function () {
    var self = this;

    this.offerCards.forEach(function (card, index) {
      var radioInput = card.querySelector(SELECTORS.RADIO_INPUT);

      if (radioInput) {
        radioInput.addEventListener('change', function () {
          if (radioInput.checked) self.selectCard(card, index);
        });
      }

      card.addEventListener('click', function (e) {
        if (e.target.classList.contains('qov4__radio-input')) return;
        e.preventDefault();
        e.stopPropagation();
        if (radioInput) {
          radioInput.checked = true;
          self.selectCard(card, index);
        }
      });
    });

    if (this.ctaButton) {
      this.ctaButton.addEventListener('click', function (e) {
        e.preventDefault();
        if (self.selectedOfferIndex === null) return;

        var selectedCard = self.offerCards[self.selectedOfferIndex];
        var selectionData = buildSelectionFromCard(selectedCard);
        self.storage.set(selectionData);
        publishFreeShipping(selectionData.freeShipping);
      });
    }
  };

  QuantityOffersV5.prototype.selectCard = function (card, index) {
    this.offerCards.forEach(function (c) {
      c.classList.remove(SELECTORS.SELECTED_CLASS);
    });
    card.classList.add(SELECTORS.SELECTED_CLASS);
    this.selectedOfferIndex = index;
    this.updateDynamicContent(card);
    publishFreeShipping(cardHasFreeShipping(card));
  };

  QuantityOffersV5.prototype.pxOrEmpty = function (value) {
    if (value == null || value === '' || value === 'undefined') return '';
    return String(value).indexOf('px') !== -1 ? String(value) : String(value) + 'px';
  };

  QuantityOffersV5.prototype.updateDynamicContent = function (card) {
    var container = document.getElementById(this.config.dynamicContentId);
    if (!container) return;

    container.classList.toggle(
      'qov4__dynamic-content--complete',
      card.dataset.enableCompleteContainer === 'true'
    );

    var section = this.section;
    this.updateCSSVariable(section, '--bonus-bg-color', card.dataset.bonusBgColor);
    this.updateCSSVariable(section, '--bonus-text-color', card.dataset.bonusTextColor);
    this.updateCSSVariable(section, '--bonus-title-color', card.dataset.bonusTitleColor);
    this.updateCSSVariable(section, '--bonus-check-color', card.dataset.bonusCheckColor);
    this.updateCSSVariable(
      section,
      '--bonus-title-font-size',
      this.pxOrEmpty(card.dataset.bonusTitleFontSize)
    );
    this.updateCSSVariable(
      section,
      '--bonus-text-font-size',
      this.pxOrEmpty(card.dataset.bonusTextFontSize)
    );
    this.updateCSSVariable(
      section,
      '--bonus-image-width',
      this.pxOrEmpty(card.dataset.bonusImageWidth)
    );
    this.updateCSSVariable(
      section,
      '--bonus-image-height',
      this.pxOrEmpty(card.dataset.bonusImageHeight)
    );
    this.updateCSSVariable(
      section,
      '--bonus-check-width',
      this.pxOrEmpty(card.dataset.bonusCheckWidth)
    );
    this.updateCSSVariable(
      section,
      '--bonus-check-height',
      this.pxOrEmpty(card.dataset.bonusCheckHeight)
    );

    container.classList.toggle('disabled', card.dataset.bonusDisabled === 'true');

    var titleElement = container.querySelector('.qov4__bonus-title');
    var bonusTitle = card.dataset.bonusTitle || '';
    var hasBonus1 = card.dataset.hasBonus1 === 'true';
    var hasBonus2 = card.dataset.hasBonus2 === 'true';
    var hasBonus3 = card.dataset.hasBonus3 === 'true';

    if (titleElement && bonusTitle && (hasBonus1 || hasBonus2 || hasBonus3)) {
      titleElement.textContent = bonusTitle;
      titleElement.classList.add('visible');
    } else if (titleElement) {
      titleElement.classList.remove('visible');
    }

    for (var i = 1; i <= 3; i++) {
      this.updateBonusItem(
        container,
        card,
        i,
        card.dataset['hasBonus' + i] === 'true',
        card.dataset['bonus' + i + 'Check'] === 'true'
      );
    }

    container.classList.toggle(
      'qov4__dynamic-content--visible',
      hasBonus1 || hasBonus2 || hasBonus3
    );
  };

  QuantityOffersV5.prototype.updateBonusItem = function (container, card, itemNum, hasBonus, isChecked) {
    var bonusItem = container.querySelector('[data-bonus="' + itemNum + '"]');
    if (!bonusItem) return;

    if (!hasBonus) {
      bonusItem.style.display = 'none';
      return;
    }

    var img = bonusItem.querySelector('img');
    var bonusImgKey = 'bonus' + itemNum + 'Img';
    if (img && card.dataset[bonusImgKey]) {
      img.src = card.dataset[bonusImgKey];
      img.srcset = card.dataset[bonusImgKey];
      img.style.display = '';
      var imgWrap = bonusItem.querySelector('.qov4__bonus-image-wrapper');
      if (imgWrap) imgWrap.style.display = '';
    } else if (img) {
      img.removeAttribute('src');
      img.removeAttribute('srcset');
      img.style.display = 'none';
      var imgWrapHidden = bonusItem.querySelector('.qov4__bonus-image-wrapper');
      if (imgWrapHidden) imgWrapHidden.style.display = 'none';
    }

    var textDiv = bonusItem.querySelector('.qov4__bonus-text');
    if (textDiv) textDiv.innerHTML = card.dataset['bonus' + itemNum + 'Text'] || '';

    var checkGreen = bonusItem.querySelector('.circle__check.green');
    var checkRed = bonusItem.querySelector('.circle__check.red');
    var checkItem = bonusItem.querySelector('.check__item');

    if (isChecked) {
      if (checkGreen) checkGreen.style.display = 'flex';
      if (checkRed) checkRed.style.display = 'none';
    } else {
      if (checkGreen) checkGreen.style.display = 'none';
      if (checkRed) checkRed.style.display = 'flex';
    }

    var enableCheck = card.dataset.enableOptionBonusCheckColor === 'true';
    if (checkItem) checkItem.style.display = enableCheck ? 'flex' : 'none';
    bonusItem.style.gridTemplateColumns = enableCheck
      ? 'auto auto minmax(0, 1fr)'
      : 'auto minmax(0, 1fr)';
    bonusItem.style.display = 'grid';
  };

  QuantityOffersV5.prototype.updateCSSVariable = function (element, variable, value) {
    if (value) element.style.setProperty(variable, value);
  };

  QuantityOffersV5.prototype.setupReleasitObserver = function () {
    var self = this;
    var observer = new MutationObserver(function (mutations) {
      if (self.isProcessing) return;
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].type !== 'childList') continue;
        var nodes = mutations[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var node = nodes[j];
          if (node.nodeType !== 1) continue;
          if (
            node.id === 'rsi-cod-form-quantity-offers-hook' ||
            (node.querySelector && node.querySelector('#rsi-cod-form-quantity-offers-hook'))
          ) {
            setTimeout(function () {
              self.syncWithReleasit();
            }, 500);
            return;
          }
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  };

  QuantityOffersV5.prototype.syncWithReleasit = function () {
    if (this.isProcessing) return;
    this.isProcessing = true;

    var storedData = this.storage.get();
    if (!storedData) {
      var card = this.getSelectedCard();
      if (card) storedData = buildSelectionFromCard(card);
    }

    if (!storedData) {
      this.isProcessing = false;
      return;
    }

    if (typeof storedData.freeShipping === 'boolean') {
      publishFreeShipping(storedData.freeShipping);
    }

    var container = document.querySelector(SELECTORS.FORM_CONTAINER);
    if (!container) {
      this.isProcessing = false;
      return;
    }

    var offersContainer = container.querySelector(SELECTORS.OFFERS_CONTAINER);
    if (!offersContainer) {
      this.isProcessing = false;
      return;
    }

    var offers = Array.prototype.slice.call(
      offersContainer.querySelectorAll(SELECTORS.OFFER_CONTAINER)
    );

    if (offers.length === 0 || storedData.offerIndex >= offers.length) {
      this.isProcessing = false;
      return;
    }

    var targetOffer = offers[storedData.offerIndex];
    if (targetOffer.classList.contains(SELECTORS.RELEASIT_SELECTED)) {
      this.finalizeSyncronization(storedData);
      return;
    }

    this.triggerReleasitSelection(targetOffer, storedData);
  };

  QuantityOffersV5.prototype.triggerReleasitSelection = function (targetOffer, storedData) {
    var self = this;

    this.performNativeClick(targetOffer, function () {
      setTimeout(function () {
        if (self.verifySelection(targetOffer)) {
          self.finalizeSyncronization(storedData);
          return;
        }

        self.tryInternalClicks(targetOffer, function () {
          setTimeout(function () {
            if (self.verifySelection(targetOffer)) {
              self.finalizeSyncronization(storedData);
              return;
            }

            self.triggerFormEvents(targetOffer, function () {
              setTimeout(function () {
                self.finalizeSyncronization(storedData);
              }, 200);
            });
          }, 200);
        });
      }, 200);
    });
  };

  QuantityOffersV5.prototype.performNativeClick = function (element, callback) {
    var events = ['mouseenter', 'mouseover', 'mousedown', 'mouseup', 'click'];
    events.forEach(function (eventType, index) {
      setTimeout(function () {
        var rect = element.getBoundingClientRect();
        element.dispatchEvent(
          new MouseEvent(eventType, {
            view: window,
            bubbles: true,
            cancelable: true,
            clientX: rect.left + rect.width / 2,
            clientY: rect.top + rect.height / 2,
          })
        );
        if (index === events.length - 1) setTimeout(callback, 50);
      }, index * 50);
    });
  };

  QuantityOffersV5.prototype.tryInternalClicks = function (targetOffer, callback) {
    var self = this;
    var clickableSelectors = [
      '._rsi-quantity-offers-offer',
      '._rsi-modal-line-item-image-container',
      '._rsi-modal-line-item-image',
      '._rsi-quantity-offers-info',
      '._rsi-quantity-offers-title',
      '._rsi-quantity-offers-prices',
    ];
    var currentIndex = 0;

    function tryNext() {
      if (currentIndex >= clickableSelectors.length) {
        callback();
        return;
      }
      var element = targetOffer.querySelector(clickableSelectors[currentIndex]);
      if (element) {
        self.performNativeClick(element, function () {
          currentIndex++;
          setTimeout(tryNext, 100);
        });
      } else {
        currentIndex++;
        tryNext();
      }
    }

    tryNext();
  };

  QuantityOffersV5.prototype.triggerFormEvents = function (targetOffer, callback) {
    var form = document.querySelector('#rsi-cod-form-quantity-offers-hook form');
    if (form) {
      form.dispatchEvent(new Event('change', { bubbles: true }));
      form.dispatchEvent(new Event('input', { bubbles: true }));
      setTimeout(function () {
        targetOffer.click();
        callback();
      }, 100);
    } else {
      callback();
    }
  };

  QuantityOffersV5.prototype.verifySelection = function (targetOffer) {
    return (
      targetOffer.classList.contains(SELECTORS.RELEASIT_SELECTED) &&
      targetOffer.querySelectorAll('._rsi-quantity-offers-item-input').length > 0
    );
  };

  QuantityOffersV5.prototype.finalizeSyncronization = function (storedData) {
    var self = this;
    setTimeout(function () {
      if (storedData && typeof storedData.freeShipping === 'boolean') {
        publishFreeShipping(storedData.freeShipping);
      }
      self.storage.clear();
      self.isProcessing = false;
    }, 100);
  };

  QuantityOffersV5.prototype.exposeDebugAPI = function () {
    window.QuantityOffersV5Debug = window.QuantityOffersV5Debug || {};
    window.QuantityOffersV5Debug[this.config.sectionId] = {
      manager: this,
      storage: this.storage,
      resetStorage: this.storage.clear.bind(this.storage),
      showStorage: this.storage.get.bind(this.storage),
      syncNow: this.syncWithReleasit.bind(this),
      syncFromPdp: this.syncFromPdpIfSelected.bind(this),
      showCards: function () {
        return this.manager.offerCards;
      }.bind({ manager: this }),
      selectedIndex: function () {
        return this.manager.selectedOfferIndex;
      }.bind({ manager: this }),
    };
  };

  function boot() {
    var pending = window.__qov5Pending || [];
    pending.forEach(function (config) {
      new QuantityOffersV5(config);
    });
    window.__qov5Pending = [];
  }

  window.__qov5Register = function (config) {
    new QuantityOffersV5(config);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
